module.exports = __webpack_public_path__ + "img/mealreminder-user-android-big.1a36f894.png";